import Configuration from "./configuration";

class ApiClient {
  private static async fetchApi<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${Configuration.API_URL}${endpoint}`;
    const response = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(`API request failed: ${error.error || response.statusText}`);
    }

    return (await response.json()) as Promise<T>;
  }

  public static async get<T>(endpoint: string, headers: Record<string, string> = {}): Promise<T> {
    const response = await this.fetchApi<T>(endpoint, { headers });
    return response as T;
  }

  public static async post<T>(endpoint: string, body: any, headers: Record<string, string> = {}): Promise<T> {
    const response = await this.fetchApi<T>(endpoint, {
      method: "POST",
      body: JSON.stringify(body),
      headers,
    });
    return response as T;
  }

  public static async put<T>(endpoint: string, body: any, headers: Record<string, string> = {}): Promise<T> {
    const response = await this.fetchApi<T>(endpoint, {
      method: "PUT",
      body: JSON.stringify(body),
      headers,
    });
    return response as T;
  }

  public static async delete<T>(endpoint: string, headers: Record<string, string> = {}): Promise<T> {
    const response = await this.fetchApi<T>(endpoint, {
      method: "DELETE",
      headers,
    });
    return response as T;
  }
}

export default ApiClient;
